<script setup>
import Button from "./ui/button/Button.vue";
import Card from "./ui/card/Card.vue";
import CardContent from "./ui/card/CardContent.vue";
import CardDescription from "./ui/card/CardDescription.vue";
import CardFooter from "./ui/card/CardFooter.vue";
import CardTitle from "./ui/card/CardTitle.vue";
import { useRouter } from "vue-router";
import Dialog from "./ui/dialog/Dialog.vue";
import DialogTrigger from "./ui/dialog/DialogTrigger.vue";
import DialogContent from "./ui/dialog/DialogContent.vue";
import DialogHeader from "./ui/dialog/DialogHeader.vue";
import DialogTitle from "./ui/dialog/DialogTitle.vue";
import DialogDescription from "./ui/dialog/DialogDescription.vue";
import DialogFooter from "./ui/dialog/DialogFooter.vue";
import DialogClose from "./ui/dialog/DialogClose.vue";
import { isDarkMode } from "@/darkmode.js";

const router = useRouter();

const emit = defineEmits(["cancelBooking"]);

const props = defineProps({
  eventName: String,
  eventId: String,
  date: String,
  seat: String,
  imageUrl: String,
});

function toBooking() {
  router.push({ name: "Confirmation", params: { id: props.eventId } });
}
function cancelBooking() {
  emit("cancelBooking");
}
</script>

<template>
  <div>
    <Card class="px-5">
      <div class="flex flex-row">
        <div class="max-h-32 aspect-square">
          <img :src="imageUrl" class="object-cover w-full h-full rounded-2xl" />
        </div>
        <CardContent class="grow max-h-32 w-full">
          <CardTitle class=""
            ><p>{{ eventName }}</p></CardTitle
          >
          <CardDescription
            ><p>Date: {{ date }}</p>
            <p>Seat: {{ seat }}</p>
          </CardDescription>
        </CardContent>
      </div>
      <CardFooter class="flex flex-row w-full gap-3 pl-0 pr-3">
        <Button class="w-1/2" @click="toBooking">View Booking</Button>
        <Dialog>
          <DialogTrigger as-child>
            <Button variant="outline" class="w-1/2">Cancel Booking </Button>
          </DialogTrigger>
          <DialogContent class="sm:max-w-[425px]" :class="{ dark: isDarkMode }">
            <DialogHeader>
              <DialogTitle>Cancel Booking</DialogTitle>
              <DialogDescription>
                Are you sure you want to cancel the booking for {{ eventName }}?
              </DialogDescription>
            </DialogHeader>
            <DialogFooter>
              <DialogClose as-child>
                <Button type="submit" variant="outline">
                  Back to bookings
                </Button>
                <Button @click="cancelBooking"> Cancel Booking </Button>
              </DialogClose>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </CardFooter>
    </Card>
  </div>
</template>

<style>
.dark {
  color: #fafafa;
}
</style>
